<template>
  <div id="notes-container">
    <div class="title">{{ $t("notes.label") }}</div>
    <div class="button add" @click="createNote">{{ $t("notes.create") }}</div>
    <div class="clear" style="height: 20px"></div>
    <div class="note_list">
      <div
        v-for="(note, key) in notes"
        class="note"
        :key="note.id"
        @click="showNote(note)"
      >
        <div class="text">
          {{ note.note }}
        </div>

        <div class="meta">
          <div class="author">{{ note.user.name }}</div>
          <div class="date">{{ note.date }}</div>
        </div>
      </div>
      <div v-if="notes.length == 0" class="note empty">
        <div class="text">
          {{ $t("notes.empty") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  components: {},
  props: { notes: Array, page: String, id: String },
  data() {
    return {};
  },
  computed: {},
  methods: {
    showNote(note) {
      note.current_page = this.page;
      note.current_id = this.id;
      this.$card.note(note);
    },

    createNote() {
      this.$emit("create_note");
    }
  },
  created() {
    var self = this;
  },

  filters: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#notes-container {
  padding: 20px;
  width: 100%;

  .title {
    padding-bottom: 5px;
    border-bottom: 2px solid $complem-color-dark;
    width: calc(100% - 200px);
  }

  .button.add {
    max-width: 200px;
    height: 35px;
    float: right;
    margin-top: -25px;
    padding: 8px 20px;
    padding-left: 35px;
    text-align: center;
    margin-right: 15px;
    border-radius: 3px;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    cursor: pointer;
    background: url("/img/add.svg") no-repeat left 10px center $complem-color;
    background-size: 15px;

    &:hover {
      background-color: $complem-color-dark;
    }
  }

  .note_list {
    display: block;
    padding: 20px;
    overflow: hidden;
    width: 100%;

    .note {
      max-width: 300px;
      width: calc(33% - 20px);
      @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      border-radius: 3px;
      padding: 20px 20px 30px 20px;
      max-height: 150px;
      height: 150px;
      float: left;
      position: relative;
      background-color: #fff;
      margin-top: 15px;
      margin-left: 15px;

      &.empty {
        padding: 20px;
        font-size: 20px;
        height: 60px;
        text-transform: uppercase;
        width: 100%;
        max-width: 100%;
        text-align: center;
        background: none;
        box-shadow: none;

        .text {
          text-align: center;
          color: #999;
        }
      }

      .text {
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        display: -webkit-box;
        line-height: 16px; /* fallback */
        max-height: 120px; /* fallback */
        -webkit-line-clamp: 5; /* number of lines to show */
        -webkit-box-orient: vertical;
        @include font-size(14px);
      }
      .meta {
        @include font-size(12px);
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
        overflow: hidden;
        padding: 10px 20px;
        color: #999;

        .date {
          display: inline-block;
          @include font-size(12px);
          color: #999;
          margin-left: 10px;
        }
        .author {
          display: inline-block;
          @include font-size(12px);
          color: #999;
          font-weight: bold;
        }
      }

      &:not(:first-child) {
        /*margin-left: 20px;*/
      }
    }
  }
}
</style>
